import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import appConfig from '../../appConfig';
import useUserTypes from '../../hooks/useUserTypes';
import UserType from '../../models/Account/UserType';

const ProtectedAdminRoute: FC = () => {
  const userTypes = useUserTypes();
  const universeBaseUrl = appConfig.universeFrontendUrl;

  if (!userTypes.includes(UserType.Admin)) {
    const redirectUrl = encodeURIComponent(window.location.href);
    window.location.href = `${universeBaseUrl}/login?redirect=${redirectUrl}`;
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;
